module.exports = __webpack_public_path__ + "static/autoreload-ca09ed2b2fc7c55f656c4f47037d22c4.png";